import { TextField as MuiTextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { Fragment, useEffect, useState } from 'react';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import { isValidNumberInput } from '../../utils/utils';
import useDebouncedCallback from '../../hooks/useDebouncedCallback';

const NumberField = ({ field }: { field: any }) => {
  const { getFormDataItem, handleChange } = useFormContext();
  const formData = useFormData();
  const formValue = getFormDataItem(formData, field.name);
  const [inputValue, setInputValue] = useState(formValue);

  const debouncedHandleChange = useDebouncedCallback((value: number) => {
    handleChange(
      {
        target: {
          name: field.name,
          value,
          type: field.type,
          checked: false,
        },
      },
      field,
    );
  }, 500);

  useEffect(() => {
    setInputValue(formValue);
  }, [formValue]);

  let isHidden = field.hasOwnProperty('isHidden') ? getFormDataItem(formData, field?.isHidden) : false;

  if (field.hasOwnProperty('revertHidden') && field?.revertHidden) {
    isHidden = !isHidden;
  }

  if (isHidden) {
    return null;
  }

  const handleNumberChange = (e: any) => {
    const value = e.target.value;

    if (isValidNumberInput(value)) {
      setInputValue(value);
      debouncedHandleChange(value);
    }
  };

  const label = field.hasOwnProperty('help') ? (
    <Fragment>
      {field.label}
      <ChartHelpTooltip chartType={field.help} type="label" />
    </Fragment>
  ) : (
    field.label
  );

  return (
    <Grid size={field.size || 12} key={field.name}>
      <MuiTextField
        error={field.error || false}
        label={label}
        fullWidth
        required={field.required || false}
        disabled={field.hasOwnProperty('disabled') ? getFormDataItem(formData, field?.disabled) : false}
        inputProps={{
          min: field.min || null,
          max: field.max || null,
        }}
        type="number"
        name={field.name}
        value={inputValue}
        onChange={handleNumberChange}
      />
    </Grid>
  );
};

export default NumberField;
